export default __webpack_public_path__ + "static/media/demandCharges.920ab260.svg";